import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-next-game.module.scss";
import {EventIcon} from "../../../../../core/components/event-icon-selector/event-icon";
import {EventTypeViewModel} from "../../../../../domain/common/events/models/event-type-view-model";
import {LINEUPS} from "../../../../lineups-widget/lineups-widget.consts";


export const AthleteNextGameModuleSuspensionRisk = observer(({controller}) => {
  const {state, device, terms} = controller;
  const {athlete} = state;
  const {isSmallView} = device;
  const {WEB_PLAYER_CARD_AT_RISK_ONE_YELLOW_FROM_SUSPENSION} = terms;

  const shouldRenderSuspensionDangerText = athlete?.suspensionRisk && athlete?.status !== LINEUPS.MEMBERS_STATUS.missing;
  const iconProps = {
    width: isSmallView ? 16 : 24,
    height: isSmallView ? 16 : 24,
    className: classNames(styles.icon_logo),
    event: new EventTypeViewModel({id: LINEUPS.EVENT_TYPES.yellowCard}),
  }

  return shouldRenderSuspensionDangerText ? <div className={classNames(styles.suspension_risk)}>
    <EventIcon {...iconProps}/>
    {WEB_PLAYER_CARD_AT_RISK_ONE_YELLOW_FROM_SUSPENSION}
  </div> : null
});
